import { render, staticRenderFns } from "./AkbsEmploymentTable.vue?vue&type=template&id=38bd913b&scoped=true&"
import script from "./AkbsEmploymentTable.vue?vue&type=script&lang=js&"
export * from "./AkbsEmploymentTable.vue?vue&type=script&lang=js&"
import style0 from "./AkbsEmploymentTable.vue?vue&type=style&index=0&id=38bd913b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd913b",
  null
  
)

export default component.exports